import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { cx } from '../lib/cx'

export interface MatriculeTagProps {
  value: string
  /**
   * Les deux matricules ne doivent jamais être confondus (cahier §4.2) :
   * le type est toujours affiché, et lu par les lecteurs d'écran.
   */
  kind: 'utilisateur' | 'candidature'
  copyable?: boolean
  className?: string
}

const KIND_LABEL = { utilisateur: 'Matricule utilisateur', candidature: 'Matricule de candidature' }
const KIND_SHORT = { utilisateur: 'Util.', candidature: 'Cand.' }

export function MatriculeTag({ value, kind, copyable = true, className }: MatriculeTagProps) {
  const [copied, setCopied] = useState(false)

  async function copy() {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      /* presse-papiers indisponible : rien à faire */
    }
  }

  return (
    <span className={cx('matricule', className)} title={KIND_LABEL[kind]}>
      <span className="matricule-kind" aria-hidden="true">
        {KIND_SHORT[kind]}
      </span>
      <span className="sr-only">{KIND_LABEL[kind]} :</span>
      <span>{value}</span>
      {copyable && (
        <button
          type="button"
          onClick={copy}
          aria-label={copied ? 'Copié' : `Copier le ${KIND_LABEL[kind].toLowerCase()}`}
        >
          {copied ? <Check aria-hidden="true" /> : <Copy aria-hidden="true" />}
        </button>
      )}
    </span>
  )
}
